import { useState, useEffect } from "react";
import { PageHeader } from "@/components/Common";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LoungeContentTab } from "@/components/lounge-admin/LoungeContentTab";
import { LoungeGuidelinesTab } from "@/components/lounge-admin/LoungeGuidelinesTab";
import { LoungeRequestsAdminTab } from "@/components/lounge-admin/LoungeRequestsAdminTab";
import { AmbassadorsTab } from "@/components/lounge-admin/AmbassadorsTab";
import { MediaLibraryTab } from "@/components/lounge-admin/MediaLibraryTab";
import { AmbassadorStatsTab } from "@/components/lounge-admin/AmbassadorStatsTab";
import { FileText, Users, ScrollText, Inbox, ExternalLink, Image as ImageIcon, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AmbassadorLoungeAdmin() {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    api.get("/lounge/pending-counts").then(({ data }) => setUnread(data.ambassador || 0)).catch(() => {});
  }, []);
  return (
    <div data-testid="ambassador-lounge-admin">
      <PageHeader
        eyebrow="Lounge"
        title="Gestione Ambassador Lounge"
        subtitle="Contenuti, ambassador, regole kit e richieste della pagina pubblica Ambassador."
        actions={
          <a href="/ambassador-lounge" target="_blank" rel="noopener noreferrer">
            <Button variant="outline" size="sm" data-testid="amb-view-public"><ExternalLink className="mr-1.5 h-4 w-4" /> Vedi pagina pubblica</Button>
          </a>
        }
      />
      <Tabs defaultValue="content">
        <TabsList className="flex-wrap">
          <TabsTrigger value="content" data-testid="amb-tab-content"><FileText className="mr-1.5 h-4 w-4" /> Contenuti</TabsTrigger>
          <TabsTrigger value="ambassadors" data-testid="amb-tab-ambassadors"><Users className="mr-1.5 h-4 w-4" /> Ambassador</TabsTrigger>
          <TabsTrigger value="media" data-testid="amb-tab-media"><ImageIcon className="mr-1.5 h-4 w-4" /> Libreria Media</TabsTrigger>
          <TabsTrigger value="rules" data-testid="amb-tab-rules"><ScrollText className="mr-1.5 h-4 w-4" /> Regole Kit</TabsTrigger>
          <TabsTrigger value="requests" data-testid="amb-tab-requests">
            <Inbox className="mr-1.5 h-4 w-4" /> Richieste
            {unread > 0 && <span className="ml-1.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-brema-red px-1 text-[10px] font-bold leading-none text-white" data-testid="amb-requests-badge">{unread}</span>}
          </TabsTrigger>
          <TabsTrigger value="stats" data-testid="amb-tab-stats"><BarChart3 className="mr-1.5 h-4 w-4" /> Statistiche & Report</TabsTrigger>
        </TabsList>
        <TabsContent value="content" className="mt-6"><LoungeContentTab page="ambassador" /></TabsContent>
        <TabsContent value="ambassadors" className="mt-6"><AmbassadorsTab /></TabsContent>
        <TabsContent value="media" className="mt-6"><MediaLibraryTab page="ambassador" /></TabsContent>
        <TabsContent value="rules" className="mt-6">
          <LoungeGuidelinesTab page="ambassador" title="Linee guida Kit Ambassador" description="Regole mostrate agli aspiranti ambassador accanto alla richiesta kit." />
        </TabsContent>
        <TabsContent value="requests" className="mt-6"><LoungeRequestsAdminTab page="ambassador" onCount={setUnread} /></TabsContent>
        <TabsContent value="stats" className="mt-6"><AmbassadorStatsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
